import * as React from 'react';
import {
  Accordion,
  AccordionTitleProps,
  Icon,
  Message
} from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { OfflineSection } from 'components/offline-section';
import { SettingsMenuItem } from 'types/settings-menu-item';
import { translations } from 'types/translations';
import { AppState } from 'pages/app/state';
import { connect } from 'react-redux';
import { ErrorMessage } from 'components/error-message';

export interface Props {
  name: string;
  title: string;
  index: SettingsMenuItem;
  activeIndex: SettingsMenuItem;
  errorMessage: string;
  setMenuItem: (event: React.MouseEvent<HTMLDivElement>, data: AccordionTitleProps) => void;
}

const SettingsSectionComponent: React.StatelessComponent<Props> = (props) => {
  const i18n = getI18n();
  const isActive = props.activeIndex === props.index;

  return (
    <>
      <Accordion.Title
        index={props.index}
        active={isActive}
        onClick={props.setMenuItem}
        className={'settings-menu-title ' + props.name}
      >
        <Icon name="dropdown" />
        {props.title}
      </Accordion.Title>
      <Accordion.Content active={isActive} className={'settings-menu-content ' + props.name}>
        <div className="padded-left">
          <ErrorMessage message={i18n.t(props.errorMessage)} />
          {props.children}
          <OfflineSection>
            <Message color="yellow">
              <Message.Content>
                <Icon className="warning" name="warning sign" />
                {i18n.t(translations.OfflineSettingsMessage)}
              </Message.Content>
            </Message>
          </OfflineSection>
        </div>
      </Accordion.Content>
    </>
  );
};

const mapStateToProps = ({ settings }: AppState) => {
  return {
    errorMessage: settings.errorMessage
  };
};

export const SettingsSection = connect(mapStateToProps)(SettingsSectionComponent);


// WEBPACK FOOTER //
// ./src/components/settings/settings-section.tsx